// extracted by mini-css-extract-plugin
module.exports = {"section01":"section01_section01__Sx5rQ"};